module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Ansprechpartner"},"en":{"title":"Contact persons"}}')
  delete Component.options._Ctor
}
